<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions" />
</template>

<script>
import {
  getNameFilter,
  getDomainFilter,
  getTenantFilter,
} from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import expectStatus from '@/constants/expectStatus'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'BastionServerList',
  mixins: [WindowsMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    resId: String,
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        resource: 'bastion_servers',
        id: 'bastion_server_id',
        getParams: {
          bastion_host_id: this.resId,
        },
        steadyStatus: {
          status: Object.values(expectStatus.server).flat(),
        },
        filterOptions: {
          id: {
            label: this.$t('table.title.id'),
          },
          name: getNameFilter(),
          projects: getTenantFilter(),
          project_domains: getDomainFilter(),
        },
      }),
      groupActions: [
        {
          label: this.$t('table.action.delete'),
          permission: 'bastion_servers_delete',
          action: () => {
            this.createDialog('BastionServersDeleteDialog', {
              vm: this,
              data: this.list.selectedItems,
              columns: this.columns,
              title: this.$t('table.action.delete'),
              name: this.$t('dictionary.server'),
              success: () => {
                setTimeout(() => {
                  this.list.refresh()
                }, 1000)
              },
            })
          },
          meta: () => ({
            validate: this.list.selectedItems.length,
          }),
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BastionServerSidePage', {
        id: row.id,
        resource: 'bastion_servers',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
